import React from "react";
import { Button, Typography } from "antd";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation

const { Text, Title } = Typography;

interface PasswordOtpVerifyProps {
  email: string;
}

const PasswordOtpVerify: React.FC<PasswordOtpVerifyProps> = ({ email }) => {
  const navigate = useNavigate(); 

  const handleReturnToHome = () => {
    navigate("/login");
  };

  return (
    <>
      <Title level={2}>We have sent a password verfication link to your email</Title>
      <Text type="secondary">
        Please <Text strong>{email}</Text> check your email and follow the instructions to reset your password.
      </Text>
      <div className="mt-12">
        <Button
          onClick={handleReturnToHome}
          type="primary"
          className="h-12 px-8 border border-2 border-border text-base flex justify-center items-center gap-2 bg-primary text-white border-none w-full mt-12"
        >
          Return to login page
        </Button>
      </div>
    </>
  );
};

export default PasswordOtpVerify;